
export interface ChatResponse {
  /** 사용된 모델명 */
  model?: string;
  /** 처리 시간 (밀리초) */
  processing_time?: number;
  /** AI 제공자 (openai, gemini, ollama 등) */
  provider?: string;
  /** AI 응답 메시지 */
  response?: string;
  /** 응답 성공 여부 */
  success?: boolean;
  /** 사용된 토큰 수 */
  tokens?: number;
}
